import React, { useState, useEffect } from 'react';
import Question from './components/Question'
import Form from './components/Form'
import List from './components/List'
import ControlBudget from './components/ControlBudget'

function App() {

  //definr el state
  const [budget, saveBudget] = useState(0);
  const [remaining, saveRemaining] = useState(0);
  const [show_question, updateShowQuestion] = useState(true);
  const [expenditures, saveExpenditures] = useState([]);
  const [expenditure, saveExpenditure] = useState([]);
  const [create_expenditure, saveCreateExpenditure] = useState(false);


  //useEffect que actualiza el restante 
  useEffect(() => {
    if (create_expenditure) {

      //agregar el nuevo presupuesto
      saveExpenditures([
        ...expenditures,
        expenditure
      ]);

      //resta del presupuesto actual
      const budget_remaining = remaining - expenditure.quantity;
      saveRemaining(budget_remaining);

      //resetear a false
      saveCreateExpenditure(false);
    }
  }, [expenditure, create_expenditure, expenditures, remaining])

  // //cuando agreguemos un nuevo gasto
  // const saveNewExpenditure = expenditure => {
  //   saveExpenditures([
  //     ...expenditures,
  //     expenditure
  //   ]);
  // }

  return (
    <div className="container">
      <header>
        <h1>Gasto Mensual</h1>
        <div className="contenido-principal contenido">
          {show_question ?
            (
              <Question
                saveBudget={saveBudget}
                saveRemaining={saveRemaining}
                updateShowQuestion={updateShowQuestion}
              />
            )
            :
            (
              <div className="row">
                <div className="one-half column">
                  <Form
                    saveExpenditure={saveExpenditure}
                    saveCreateExpenditure={saveCreateExpenditure}
                  />
                </div>
                <div className="one-half column">
                  <List
                    expenditures={expenditures}
                  />
                  <ControlBudget
                    budget={budget}
                    remaining={remaining}
                  />
                </div>
              </div>
            )

          }
        </div>
      </header>
    </div>
  );
}

export default App;
